// Initialize theme before page render to prevent flash
(function() {
  const savedTheme = localStorage.getItem('theme');
  const shouldBeDark = savedTheme === 'dark';

  if (shouldBeDark) {
    document.documentElement.classList.add('dark');
  } else {
    document.documentElement.classList.remove('dark');
  }
})();

// Theme toggle functionality
document.addEventListener('DOMContentLoaded', function() {
  const themeToggle = document.getElementById('theme-toggle');
  const lightIcon = document.getElementById('theme-toggle-light-icon');
  const darkIcon = document.getElementById('theme-toggle-dark-icon');
  const colorSchemeMeta = document.getElementById('color-scheme-meta');

  // Update icon display based on current theme
  function updateThemeIcon() {
    const isDark = document.documentElement.classList.contains('dark');
    if (isDark) {
      // Show sun icon in dark mode (clicking will go to light)
      lightIcon.classList.remove('hidden');
      darkIcon.classList.add('hidden');
      colorSchemeMeta.setAttribute('content', 'dark');
    } else {
      // Show moon icon in light mode (clicking will go to dark)
      lightIcon.classList.add('hidden');
      darkIcon.classList.remove('hidden');
      colorSchemeMeta.setAttribute('content', 'light');
    }
  }

  // Initialize icon on page load
  updateThemeIcon();

  // Toggle theme on button click
  themeToggle.addEventListener('click', function() {
    const html = document.documentElement;
    const isDark = html.classList.contains('dark');

    if (isDark) {
      // Switch to light mode
      html.classList.remove('dark');
      localStorage.setItem('theme', 'light');
    } else {
      // Switch to dark mode
      html.classList.add('dark');
      localStorage.setItem('theme', 'dark');
    }

    // Update icon to match new theme
    updateThemeIcon();
  });

  // Language dropdown functionality
  window.toggleDropdown = function() {
    const menu = document.getElementById('dropdown-menu');
    menu.classList.toggle('hidden');
  };

  // Close dropdown when clicking outside
  document.addEventListener('click', function(event) {
    const dropdown = document.getElementById('language-dropdown');
    const menu = document.getElementById('dropdown-menu');
    if (dropdown && !dropdown.contains(event.target)) {
      menu.classList.add('hidden');
    }
  });
});
